import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';

const playerOptions = {
  width: 800,
  aspectRatio: '16:9',
  controls: true,
  controlsBar: {
    /** devo disattivare eslint perchè il setting viene rispettato
     * da videojs solo se tra apici
     */
    // eslint-disable-next-line prettier/prettier
    'pictureInPictureToggle': false,
  },
  liveui: true,
  autoplay: 'muted',
  muted: true,
  bigPlayButton: false,
};

let mainPlayer;

export const initVideo = () => {
  const videoDiv = document.querySelector('.video-js');
  mainPlayer = videojs(videoDiv, playerOptions, () => {
    mainPlayer.src(
      'https://ilsole24ore-d360.akamaized.net/hls/live/2035173/primoround-live-2022/master.m3u8',
    );
    mainPlayer.play();
  });
};

export const deleteVideo = () => {
  mainPlayer.dispose();
};

export const disableFullScreen = () => {
  if (mainPlayer && mainPlayer.isFullscreen()) {
    mainPlayer.exitFullscreen();
  }
};
